module.exports = __webpack_public_path__ + "img/active-app.da045527.png";